<div class="icon-container" [style.width.px]="size" [style.height.px]="size">
  <img src="assets/custom-icons/{{iconName}}.svg" />
</div>
